
import DOMPurify from 'dompurify';

export const sanitizeText = (text?: string) => {
    if(!text) return text;
  return DOMPurify.sanitize(text);
};